"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var styles_1 = require("@mui/material/styles");
var CookieConsent_1 = require("../CookieConsent");
var MainAppBar_1 = __importDefault(require("./MainAppBar"));
var BelowToolbar_1 = __importDefault(require("./BelowToolbar"));
var TemporarySidebar_1 = __importDefault(require("../Sidebar/TemporarySidebar"));
var PermanentSidebar_1 = __importDefault(require("../Sidebar/PermanentSidebar"));
var PageFrame_1 = __importDefault(require("../PageFrame"));
var Base = function (_a) {
    var children = _a.children, useFeedback = _a.useFeedback, appVersion = _a.appVersion, menu = _a.menu, usePageFrame = _a.usePageFrame, _b = _a.sidebarExpandType, sidebarExpandType = _b === void 0 ? 'OVERLAY' : _b, _c = _a.openByDefault, openByDefault = _c === void 0 ? true : _c, privateApp = _a.privateApp, appBarProps = __rest(_a, ["children", "useFeedback", "appVersion", "menu", "usePageFrame", "sidebarExpandType", "openByDefault", "privateApp"]);
    var theme = (0, styles_1.useTheme)();
    var isSmallScreen = (0, useMediaQuery_1.default)(theme.breakpoints.down('sm'), { noSsr: true });
    var isTemporary = sidebarExpandType === 'OVERLAY' || isSmallScreen;
    var _d = (0, react_1.useState)(!isTemporary && openByDefault), expanded = _d[0], setExpanded = _d[1];
    var toggleExpanded = function () {
        setExpanded(!expanded);
    };
    var content = usePageFrame ? React.createElement(PageFrame_1.default, null, children) : children;
    return (React.createElement(CookieConsent_1.CookieConsentContextProvider, { disabled: privateApp },
        React.createElement(MainAppBar_1.default, __assign({}, appBarProps, { onExpand: isTemporary ? toggleExpanded : undefined })),
        isTemporary && (React.createElement(TemporarySidebar_1.default, { useFeedback: useFeedback, appName: appBarProps.appName, appVersion: appVersion, open: expanded, onClose: toggleExpanded }, menu)),
        React.createElement(BelowToolbar_1.default, null,
            React.createElement(PermanentSidebar_1.default, { expanded: expanded, onToggle: sidebarExpandType === 'NORMAL' || isSmallScreen ? toggleExpanded : undefined }, menu),
            content)));
};
exports.Base = Base;
